import React from "react";
import { motion } from "framer-motion";

const skillCategories = [
  {
    title: "languages",
    skills: [
      { name: "JavaScript", logo: "/logos/javascript.png" },
      { name: "TypeScript", logo: "/logos/ts.png" },
      { name: "Golang", logo: "/logos/golang.png" },
      { name: "PHP", logo: "/logos/php.png" },
    ],
  },
  {
    title: "frontend",
    skills: [
      { name: "React & React Native", logo: "/logos/react.png" },
      { name: "NEXT.JS", logo: "/logos/next.png" },
      { name: "Tailwind", logo: "/logos/tailwind.png" },
      { name: "Bootstrap", logo: "/logos/bootstrap.png" },
      { name: "HTML5", logo: "/logos/html.png" },
      { name: "CSS3", logo: "/logos/css.png" },
    ],
  },
  {
    title: "backend_&_database",
    skills: [
      { name: "Node.js", logo: "/logos/nodejs.png" },
      { name: "Sequelize", logo: "/logos/sequelize.png" },
      { name: "PostgreSQL", logo: "/logos/postgresql.png" },
      { name: "MySQL", logo: "/logos/mysql.png" },
      { name: "MongoDB", logo: "/logos/mongodb.png" },
      { name: "Redis", logo: "/logos/redis.svg" },
    ],
  },
  {
    title: "devops_&_tools",
    skills: [
      { name: "Docker", logo: "/logos/docker.png" },
      { name: "AWS", logo: "/logos/aws.png" },
      { name: "Firebase", logo: "/logos/firebase.svg" },
      { name: "GitHub", logo: "/logos/github.png" },
      { name: "GitLab", logo: "/logos/gitlab.png" },
      { name: "JWT", logo: "/logos/jwt.png" },
      { name: "Jest", logo: "/logos/jest.png" },
    ],
  },
];

const Skills = () => {
  return (
    <section className="relative overflow-hidden py-16 sm:py-24">
      <div className="absolute inset-0 bg-dark-900" />
      <div className="absolute inset-0 grid-overlay" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          className="mb-10 sm:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="font-mono text-xs text-gray-400 block mb-3">
            {"// "}section.skills
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
            Skills & <span className="text-glow">Technologies</span>
          </h2>
          <div className="section-divider mt-4 max-w-xs" />
        </motion.div>

        <div className="space-y-8 sm:space-y-10">
          {skillCategories.map((category, catIndex) => (
            <motion.div
              key={category.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: catIndex * 0.08 }}
            >
              <div className="flex items-center gap-3 mb-4 sm:mb-5">
                <span className="font-mono text-xs text-sky-400">
                  {">"} {category.title}
                </span>
                <div className="flex-1 h-px bg-sky-400/10" />
              </div>

              <div className="grid gap-2 sm:gap-3 grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8">
                {category.skills.map((skill, index) => (
                  <motion.div
                    key={skill.name}
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: catIndex * 0.05 + index * 0.03 }}
                    className="group"
                  >
                    <div className="glass-card p-2 sm:p-3 flex flex-col items-center justify-center aspect-square cursor-default group-hover:border-sky-400/30 group-hover:shadow-[0_0_15px_rgba(56,189,248,0.08)] transition-all duration-300">
                      <img
                        src={skill.logo}
                        alt={`${skill.name} logo`}
                        className="h-7 sm:h-8 md:h-10 lg:h-12 object-contain mb-1.5 sm:mb-2 opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"
                      />
                      <p className="font-mono text-[8px] sm:text-[9px] md:text-[10px] text-gray-400 group-hover:text-sky-300 text-center leading-tight transition-colors duration-300">
                        {skill.name}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
